import * as React from 'react';
import { withTranslation, WithTranslation } from "react-i18next";
import './statusTaskModule.scss';
import { getSentNotification, exportNotification, cancelScheduledMessage, getTemplate } from '../../apis/messageListApi';
import { useParams } from 'react-router-dom';
import * as AdaptiveCards from "adaptivecards";
import { app, dialog, UrlDialogInfo } from "@microsoft/teams-js";
import moment from 'moment';
import {
    getInitAdaptiveCard, setCard
} from '../AdaptiveCard/adaptiveCard';
import { formatDate, formatDuration, formatNumber } from '../../i18n';
import { TFunction } from "i18next";
import { markDownToHtml } from '../../helpers/formattingHelper'
import { ITemplate } from '../../templateModel'
import {
    getInitIncidentAdaptiveCard, setAreaInvolved, setSeverity, setNetworkAffected,
    setAgencyAffected, setServiceImpact, setIssueStartTime, setIncidentCardTitle,
    setLatestUpdate, setActionsIncident
} from '../AdaptiveCard/incidentAdaptiveCard';
import { Button, Spinner, Tooltip, Persona, Link } from "@fluentui/react-components"
import { ArrowDownload24Filled, Checkmark48Regular, Dismiss48Regular } from "@fluentui/react-icons"
import { INewsletter, INewsSection, prepareNewsTemplateCard } from '../NewMessage/newsTemplate';
import { initializeTeamsApp } from '../../helpers/teamsApp';
import { withRouter } from '../../helpers/withRouter';


export interface IListItem {
    header: string,
    media: JSX.Element,
}

export interface IAction {
    title: string,
    link: string
}

export interface IUpdateDetails {
    date: Date,
    message: string,
}

export interface IMessage {
    id: string;
    title: string;
    acknowledgements?: string;
    reactions?: string;
    responses?: string;
    succeeded?: string;
    failed?: string;
    unknown?: string;
    sentDate?: string;
    imageLink?: string;
    videoLink?: string;
    videoImageLink?: string;
    summary?: string;
    summary2?: string;
    author?: string;
    updateType: string;
    buttonLink?: string;
    buttonTitle?: string;
    teamNames?: string[];
    rosterNames?: string[];
    groupNames?: string[];
    userNames?: string[];
    allUsers?: boolean;
    sendingStartedDate?: string;
    sendingDuration?: string;
    errorMessage?: string;
    warningMessage?: string;
    canDownload?: boolean;
    sendingCompleted?: boolean;
    isScheduled?: boolean;
    scheduledDate?: string;
    sender?: string,
    creator?: string,
    usersListFile?: string;
    actions: IAction[],
    incidentSeverity: string,
    areasInvolved: string[],
    networkAffected: string,
    agencyAffected: string,
    serviceImpact: string,
    incidentCardTitle: string,
    incidentUpdates: IUpdateDetails[],
    latestUpdateValue: string,
    issueStartTime?: Date,
    latestUpdate: string,
    latestUpdateDate?: Date,
    newsletterHeader?: string
}

export interface IStatusState {
    message: IMessage;
    loader: boolean;
    page: string;
    teamId?: string;
    template: any;
}

interface StatusTaskModuleProps extends WithTranslation {
    params?: any;
}

class StatusTaskModule extends React.Component<StatusTaskModuleProps, IStatusState> {
    readonly localize: TFunction;
    private initMessage = {
        id: "",
        title: "",
        updateType: "",
        actions: [],
        incidentSeverity: "",
        areasInvolved: [],
        networkAffected: "",
        agencyAffected: "",
        serviceImpact: "",
        incidentCardTitle: "",
        incidentUpdates: [],
        latestUpdateValue: "",
        latestUpdate: "",
    };

    private card: any;
    private incidentCard: any;

    constructor(props: StatusTaskModuleProps) {
        super(props);

        this.localize = this.props.t;

        this.card = getInitAdaptiveCard(this.props.t);
        this.incidentCard = getInitIncidentAdaptiveCard(this.localize);

        this.state = {
            message: this.initMessage,
            loader: true,
            page: "ViewStatus",
            teamId: '',
            template: null,
        };
    }

    public async componentDidMount() {        
        initializeTeamsApp().then(() => {
            app.getContext().then((context: app.Context) => {
                this.setState({
                    teamId: context.team?.internalId,
                });
            });
        });

        const params = this.props.params;
        let id = params?.id as string;

        if (id) {
            this.getItem(id).then((message) => {     
                this.getTemplate(message.updateType).then(() => {
                    this.setState({
                        loader: false
                    }, () => {

                        var card;
                        if (this.state.message.updateType === "010") {
                            setIncidentCardTitle(this.incidentCard, this.state.message.incidentCardTitle)
                            setSeverity(this.incidentCard, this.state.message.incidentSeverity)
                            setAreaInvolved(this.incidentCard, this.state.message.areasInvolved)
                            setNetworkAffected(this.incidentCard, this.state.message.networkAffected)
                            setAgencyAffected(this.incidentCard, this.state.message.agencyAffected)
                            setServiceImpact(this.incidentCard, this.state.message.serviceImpact)
                            setIssueStartTime(this.incidentCard, moment(new Date(this.state.message.issueStartTime!)).format("MM/DD/YYYY hh:mm A"))
                            setActionsIncident(this.incidentCard, this.state.message.actions)
                            var setDateOnCard = this.state.message.latestUpdateDate ? moment(new Date(this.state.message.latestUpdateDate!)).format("MM/DD/YYYY hh:mm A") : "";
                            if (this.state.message.latestUpdate.length > 0) {
                                setLatestUpdate(this.incidentCard, this.state.message.latestUpdate, setDateOnCard)
                            }
                            card = this.incidentCard
                        } else if (this.state.message.updateType === "999") {
                            const separator = "%%||";

                            const titles = this.state.message.title.split(separator);
                            const imageLinks = this.state.message.imageLink?.split(separator) || [];;
                            const summaries = this.state.message.summary?.split(separator) || [];

                            var sections = titles.map((title, index) => ({
                                title: title,
                                summary: summaries[index],
                                imageUrl: imageLinks[index]
                            } as INewsSection))

                            var letter = {
                                sections: sections,
                                header: this.state.message.newsletterHeader,
                                actions: this.state.message.actions
                            } as INewsletter

                            card = prepareNewsTemplateCard(letter)
                        } else {
                            setCard(this.localize, this.card, this.state.template.elements, this.state.template.textColor, this.state.message, this.state.template)
                            card = this.card
                        }

                        let adaptiveCard = new AdaptiveCards.AdaptiveCard();
                        AdaptiveCards.AdaptiveCard.onProcessMarkdown = function (text, result) {
                            result.outputHtml = markDownToHtml(text);
                            result.didProcess = true;
                        };

                        adaptiveCard.parse(card);
                        let renderedCard = adaptiveCard.render() as HTMLElement;
                        document.getElementsByClassName('adaptiveCardContainer')[0].appendChild(renderedCard);
                        let link = this.state.message.buttonLink;
                        adaptiveCard.onExecuteAction = function (action) { window.open(link, '_blank'); }
                    });
                })
            });
        }
    }

    private getItem = async (id: string) => {
        try {
            const response = await getSentNotification(id);
            response.data.sendingDuration = formatDuration(response.data.sendingStartedDate, response.data.sentDate);
            response.data.sendingStartedDate = formatDate(response.data.sendingStartedDate);
            response.data.sentDate = formatDate(response.data.sentDate);
            response.data.succeeded = formatNumber(response.data.succeeded);
            response.data.failed = formatNumber(response.data.failed);
            response.data.unknown = response.data.unknown && formatNumber(response.data.unknown);
            this.setState({
                message: response.data
            });
            return response.data;
        } catch (error) {
            return error;
        }
    }

    private getTemplate = async (id: string) => {
        try {
            console.log(id)
            let response = await getTemplate(id);
            const templateData = response.data;

            var newTemplate: ITemplate = {
                id: templateData.id,
                templateName: templateData.templateName,
                indexOrder: templateData.indexOrder,
                bannerUrl: templateData.bannerUrl,
                backgroundColorUrl: templateData.backgroundColorUrl,
                textColor: templateData.textColor,
                isEmailEnabled: templateData.isEmailEnabled,
                authorGroups: templateData.authorGroups,
                emailOffSet: templateData.emailOffSet,
                allowSendAll: templateData.allowSendAll,
                isIncidentSummary: templateData.isIncidentSummary,
                isPowerAutomateEnabled: templateData.isPowerAutomateEnabled,
                elements: templateData.elements,
            }
            this.setState({
                template: newTemplate
            });
        } catch (error) {
            return error;
        }
    }

    public render(): JSX.Element {
        if (this.state.loader) {
            return (
                <div className="loader">
                    <Spinner />
                </div>
            );
        } else {
            if (this.state.page === "ViewStatus") {
                return (
                    <div className="taskModule">
                        <div className="formContainer">
                            <div className="formContentContainer" >
                                <div className="contentField">
                                    <h3>{this.localize("TitleText")}</h3>
                                    <span>{this.state.message.newsletterHeader || this.state.message.title}</span>
                                </div>
                                <div className="contentField">
                                    <h3>{this.localize("SendingStarted")}</h3>
                                    <span>{this.state.message.sendingStartedDate}</span>
                                </div>
                                {this.state.message.sendingCompleted && (
                                    <>
                                        <div className="contentField">
                                            <h3>{this.localize("Completed")}</h3>
                                            <span>{this.state.message.sentDate}</span>
                                        </div>

                                        <div className="contentField">
                                            <h3>{this.localize("Duration")}</h3>
                                            <span>{this.state.message.sendingDuration}</span>
                                        </div>
                                    </>
                                )}
                                {this.state.message.isScheduled && (
                                    <div className="contentField">
                                        <h3>Scheduled Date</h3>
                                        <span>{moment(new Date(this.state.message.scheduledDate!)).format("MM/DD/YYYY hh:mm A")}</span>
                                    </div>
                                )}

                                {this.state.message.creator && (
                                    <div className="contentField">
                                        <h3>{this.localize("CreatedBy")}</h3>
                                        <span>{this.state.message.creator}</span>
                                    </div>
                                )}

                                {this.state.message.sender && (
                                    <div className="contentField">
                                        <h3>{this.localize("SentBy")}</h3>
                                        <span>{this.state.message.sender}</span>
                                    </div>
                                )}

                                <div className="contentField">
                                    <h3>{this.localize("Results")}</h3>
                                    <label>{this.localize("Success", { "SuccessCount": this.state.message.succeeded })}</label>
                                    <br />
                                    <label>{this.localize("Failure", { "FailureCount": this.state.message.failed })}</label>
                                    <br />
                                    {this.state.message.unknown &&
                                        <>
                                            <label>{this.localize("Unknown", { "UnknownCount": this.state.message.unknown })}</label>
                                        </>
                                    }
                                </div>
                                <div className="contentField">
                                    {this.renderAudienceSelection()}
                                </div>
                                <div className="contentField">
                                    {this.renderErrorMessage()}
                                </div>
                                <div className="contentField">
                                    {this.renderWarningMessage()}
                                </div>
                            </div>
                            <div className="adaptiveCardContainer">
                            </div>
                        </div>

                        <div className="footerContainer">
                            <div className={this.state.message.canDownload ? "" : "disabled"}>
                                <div className="buttonContainer">
                                    <Spinner id="sendingLoader" className="hiddenLoader sendingLoader" size="extra-small" label={this.localize("ExportLabel")} labelPosition="after" />
                                    {(this.state.message.sendingCompleted && !this.state.message.canDownload)
                                        ? <Tooltip relationship='label' content={this.localize("ExportButtonProgressText")}>
                                            <Button icon={<ArrowDownload24Filled />} disabled={!this.state.message.canDownload || !this.state.message.sendingCompleted} id="exportBtn" onClick={this.onExport} appearance='primary' >{this.localize("ExportButtonText")}</Button>
                                        </Tooltip>
                                        : <Button icon={<ArrowDownload24Filled />} disabled={!this.state.message.canDownload || !this.state.message.sendingCompleted} id="exportBtn" onClick={this.onExport} appearance='primary' >{this.localize("ExportButtonText")}</Button>
                                    }
                                </div>
                            </div>
                            {this.state.message.isScheduled && !this.state.message.sendingCompleted && (
                                <>
                                    <div className="scheduledButtonContainer">
                                        <Spinner id="sendingLoader" className="hiddenLoader sendingLoader" size="extra-small" label={"Edit"} labelPosition="after" />
                                        <Button id="cancelBtn" onClick={this.onEditScheduledTask} appearance='secondary' >Edit</Button>
                                    </div>
                                    <div className="scheduledButtonContainer">
                                        <Spinner id="sendingLoader" className="hiddenLoader sendingLoader" size="extra-small" label={"Redraft"} labelPosition="after" />
                                        <Button id="cancelBtn" onClick={this.onCancelScheduledTask} appearance='primary' >Redraft</Button>
                                    </div>

                                </>
                            )}
                        </div>
                    </div>
                );
            }
            else if (this.state.page === "SuccessPage") {
                return (
                    <div className="taskModule">
                        <div className="formContainer">
                            <div className="displayMessageField">
                                <br />
                                <br />
                                <Checkmark48Regular className="iconStyle" />
                                <h1>{this.localize("ExportQueueTitle")}</h1>
                                <span>{this.localize("ExportQueueSuccessMessage1")}</span>
                                <br />
                                <br />
                                <span>{this.localize("ExportQueueSuccessMessage2")}</span>
                                <br />
                                <span>{this.localize("ExportQueueSuccessMessage3")}</span>
                            </div>
                        </div>
                        <div className="footerContainer">
                            <div className="buttonContainer">
                                <Button id="closeBtn" onClick={this.onClose} appearance='primary'>{this.localize("CloseText")}</Button>
                            </div>
                        </div>
                    </div>

                );
            }
            else {
                return (
                    <div className="taskModule">
                        <div className="formContainer">
                            <div className="displayMessageField">
                                <br />
                                <br />
                                <Dismiss48Regular className="iconStyle" />
                                <h1 className="light">{this.localize("ExportErrorTitle")}</h1>
                                <span>{this.localize("ExportErrorMessage")}</span>
                            </div>
                        </div>
                        <div className="footerContainer">
                            <div className="buttonContainer">
                                <Button id="closeBtn" onClick={this.onClose} appearance='primary' >{this.localize("CloseText")}</Button>
                            </div>
                        </div>
                    </div>
                );
            }
        }
    }

    public onOpenTaskModule = (event: any, url: string, title: string) => {
        const urlDialogInfo: UrlDialogInfo = {
            url: url,
            title: title,
            size: {
                height: 660,
                width: 1000
            },
            fallbackUrl: url
        }

        dialog.url.open(urlDialogInfo);
    }


    private onClose = () => {
        dialog.url.submit();
    }

    private close = (isEditSchedule?: boolean) => {
        if (isEditSchedule) {
            dialog.url.submit("editing");
        }
        dialog.url.submit();
    }

    private onExport = async () => {
        let spanner = document.getElementsByClassName("sendingLoader");
        spanner[0].classList.remove("hiddenLoader");
        let payload = {
            id: this.state.message.id,
            teamId: this.state.teamId
        };
        await exportNotification(payload).then(() => {
            this.setState({ page: "SuccessPage" });
        }).catch(() => {
            this.setState({ page: "ErrorPage" });
        });
    }

    private onCancelScheduledTask = async () => {
        await cancelScheduledMessage(this.state.message.id).then(() => {
            this.onClose();
        }).catch(() => {
            //onClose???
            this.setState({ page: "ErrorPage" });
        });
    }

    private onEditScheduledTask = async () => {
        // let url = getBaseUrl() + "/newmessage/scheduled/" + this.state.message.id + "?locale={locale}";
        // this.onOpenTaskModule(null, url, this.localize("EditMessage"));
        this.close(true);
    }

    private getItemList = (items: string[]): JSX.Element => (<ul className='audienceList'>
        {items.map(x => (
            <li key={x}><Persona name={x} textAlignment="center" avatar={{ color: "colorful", "aria-hidden": true }} /></li>
        ))}
    </ul>)

    private renderAudienceSelection = () => {
        let recipents: JSX.Element[] = []
        if (this.state.message.teamNames && this.state.message.teamNames.length > 0) {
            recipents.push(
                <div key="teamNames"> <span className="label">{this.localize("TeamsLabel")}</span>
                    {this.getItemList(this.state.message.teamNames)}
                </div>
            );
        }
        if (this.state.message.rosterNames && this.state.message.rosterNames.length > 0) {
            recipents.push(
                <div key="rosterNames"> <span className="label">{this.localize("TeamsMembersLabel")}</span>
                    {this.getItemList(this.state.message.rosterNames)}
                </div>);
        }
        if (this.state.message.groupNames && this.state.message.groupNames.length > 0) {
            recipents.push(
                <div key="groupNames" > <span className="label">{this.localize("GroupsMembersLabel")}</span>
                    {this.getItemList(this.state.message.groupNames)}
                </div>);
        }
        if (this.state.message.usersListFile || this.state.message.userNames && this.state.message.userNames.length > 0) {
            recipents.push(
                <div key="userNames" > <span className="label">{"User(s): "}</span>
                    {this.state.message.usersListFile && (<Link target="_blank" href={"/api/Content/getUsersAudience?fileName=" + this.state.message.usersListFile}>{this.state.message.usersListFile}</Link>)}
                    {this.getItemList(this.state.message.userNames!)}
                </div>);
        }
        if (this.state.message.allUsers) {
            recipents.push(
                <div>
                    <h3>{this.localize("SendToAllUsers")}</h3>
                </div>);
        } else {
            recipents.push(<div></div>);
        }

        return (<>{recipents}</>)
    }

    private renderErrorMessage = () => {
        if (this.state.message.errorMessage) {
            return (
                <div>
                    <h3>{this.localize("Errors")}</h3>
                    <span>{this.state.message.errorMessage}</span>
                </div>
            );
        } else {
            return (<div></div>);
        }
    }

    private renderWarningMessage = () => {
        if (this.state.message.warningMessage) {
            return (
                <div>
                    <h3>{this.localize("Warnings")}</h3>
                    <span>{this.state.message.warningMessage}</span>
                </div>
            );
        } else {
            return (<div></div>);
        }
    }
}

const StatusTaskModuleWithTranslation = withTranslation()(StatusTaskModule);
export default withRouter(StatusTaskModuleWithTranslation);